<!--
 * @Author: xutao
 * @Date: 2023-03-07 12:05:37
 * @LastEditors: xutao
 * @LastEditTime: 2023-03-29 13:59:11
 * @FilePath: \homesite-web\src\components\earthCard\index.vue
 * @Description:
 *
 * Copyright (c) 2023 by 用户/公司名, All Rights Reserved.
-->
<template>
  <!-- <el-card :body-style="{
      background: '#ebebeb'
    }" class="card"> -->
  <div @click="showDetail(imgData)" style="cursor: pointer;">
    <div style="overflow: hidden;height: 234px;position: relative;border-radius: 20px;">
      <!-- <el-image style="width: 100%;height:100%;display:block;z-index: 0"
                src="https://static.daspatial.com/static/img/cart_bg.png" fit="cover"></el-image> -->
      <div class="box_img">
        <div v-if="imgData.cover" :style="
          'background-image: url(' +
          imgData.cover +
          '); background-size: cover; background-position: center; width:234px; height:234px;'
        ">
        </div>
        <el-image style="display: block;width: 100%; height: 100%"
          src="https://static.daspatial.com/static/img/defaultM.png" fit="cover" v-else></el-image>
      </div>
    </div>

    <div class="list_b">
      <div class="centerBox">
        <div class="viewTimeStyle centetBox" style="justify-content: space-between">

          <div v-if="imgData.name.length < 10" class="textEllipsis2">
            {{ imgData.name }}
          </div>

          <div class="centetBox numStyle" style="justify-content: flex-end">
            <img style="width: 10px;margin: 0 4px 0 0" src="https://static.daspatial.com/static/img/model/1.svg" alt />
            <span>{{ imgData.viewTimes | num }}</span>
            <img style="width: 10px;margin: 0 4px 0 10px" src="https://static.daspatial.com/static/img/model/34.svg"
              alt />
            <span>{{ imgData.commentNum | num }}</span>
            <img style="width: 10px;margin: 0 4px 0 10px" src="https://static.daspatial.com/static/img/model/2.svg" alt />
            <span>{{ imgData.likeNum | num }}</span>
          </div>
        </div>
      </div>
      <div class="centetBox">
        <el-avatar v-if="isbgavatar(imgData.avatar) == -1" style="width: 24px;height: 24px;border-radius: 50%"
          :src="imgData.avatar"></el-avatar>

        <img v-else class="tu" src="https://static.daspatial.com/static/img/userInfo/avatar-48.png" alt="" />

        <span class="t1" :title="imgData.nickname">{{ imgData.nickname }}</span>
        <template v-if="imgData.memberLevel">
          <img class="tu2" src="https://static.daspatial.com/static/img/avater/14.png" v-if="imgData.memberLevel == 1"
            alt="" />
          <img class="tu2" src="https://static.daspatial.com/static/img/avater/15.png"
            v-else-if="imgData.memberLevel == 2" alt="" />
          <img class="tu2" src="https://static.daspatial.com/static/img/avater/16.png"
            v-else-if="imgData.memberLevel == 3" alt="" />
        </template>
      </div>
    </div>
  </div>

  <!-- </el-card> -->
</template>

<script>

export default {
  name: "wisdom-banner",
  props: {
    imgData: Object,

  },
  data() {
    return {
      imgtail: "?imageView2/1/w/600/h/400/q/70",
    };
  },
  mounted() {

  },
  methods: {
    isbgavatar(src) {
      if (!src) return -1;
      return src.indexOf("avatar.jpg");
    },
    showDetail(item) {
      if (item.viewPermission == "PRIVATE") return (this.orderData.data = {});
      this.id = item.dataSetId;
      // let routeUrl = this.$router.resolve({
      //   path: "https://www.get3d.cn/square",
      //   // query: { dataSetId: item.dataSetId, modelId: item.modelId }
      //   query: { dataSetId: item.dataSetId }
      // });
      let href = `https://www.get3d.cn/square?dataSetId=${item.dataSetId}`
      window.open(href);
    },
  },
  filters: {
    num(n) {
      if (!n) return "0";
      let arr = [];
      if (n > 999 && n < 10000) {
        n = n / 1000;
        if (n % 1 == 0) {
          return n + ".0k";
        }
        arr = n.toString().split(".");

        return arr[0] + "." + arr[1].slice(0, 1) + "k";
      } else if (n > 9999 && n < 100000) {
        n = n / 10000;
        if (n % 1 == 0) {
          return n + ".0w";
        }
        arr = n.toString().split(".");
        return arr[0] + "." + arr[1].slice(0, 1) + "w";
      } else return n;
    }
  },
}
</script>
<style scoped lang="scss">
.box_img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.list_b {
  padding: 12px 0;
  font-size: 12px;
  font-weight: normal;
}

.list_b>div:nth-child(1) {
  justify-content: space-between;
}

.list_b>div:nth-child(2) {
  margin-top: 8px;

  .t1 {
    // max-width: calc(100% - 68px);
    max-width: 120px;
    font-weight: 700;
    // font-family: font3;
    color: #333333;
    height: 17px;
    line-height: 18px;
    margin-left: 8px;
    overflow: hidden;
    // white-space: nowrap;
    white-space: pre;
    text-overflow: ellipsis;
  }

  .tu {
    display: block;
    width: 24px;
    height: 24px;
    object-fit: cover;
    border-radius: 50%;
  }

  .tu2 {
    width: 12px;
    height: 12px;
    object-fit: cover;
    margin-left: 4px;
  }
}

.list_b_t {
  height: 20px;
  color: #858585;
}

.centetBox {
  display: flex;
  align-items: center;
}

.numStyle {
  max-width: 100px;
}

.numStyle span {
  font-size: 10px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.9);
  ;
}
</style>



// WEBPACK FOOTER //
// src/components/earthCard/index.vue